import script from "./horizontal.vue?vue&type=script&setup=true&lang=js"
export * from "./horizontal.vue?vue&type=script&setup=true&lang=js"

import "./horizontal.vue?vue&type=style&index=0&id=9d247f70&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9d247f70"]])

export default __exports__